
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 3H12.5V0H11.5V3ZM5.5 10.5C5.5 6.91015 8.41015 4 12 4C15.5899 4 18.5 6.91015 18.5 10.5C18.5 12.7477 17.3491 14.7954 15.5 15.9782V19H8.5V15.9782C6.65086 14.7954 5.5 12.7477 5.5 10.5ZM14.5 15.4089L14.7496 15.2645C16.4383 14.2876 17.5 12.4866 17.5 10.5C17.5 7.46243 15.0376 5 12 5C8.96243 5 6.5 7.46243 6.5 10.5C6.5 12.4866 7.56166 14.2876 9.25036 15.2645L9.5 15.4089V18H14.5V15.4089ZM6.82843 4.12131L6.12132 4.82841L4 2.70709L4.70711 1.99999L6.82843 4.12131ZM13 23C13.5523 23 14 22.5523 14 22H10C10 22.5523 10.4477 23 11 23H13ZM17.7071 4.82843L17 4.12132L19.1213 2L19.8284 2.70711L17.7071 4.82843ZM15 20H9V21H15V20Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiTipsFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
